import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { FAQS, BRAND } from "../lib/constants";

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32 bg-[#F8F9FA]/40 relative"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14 max-w-2xl mx-auto">
          <span className="gold-divider mb-5">Common Questions</span>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light text-[#005165] leading-[1.08]">
            Answers, simply put.
          </h2>
          <p className="mt-5 text-[#4B5563]">
            Have a question we haven't covered?{" "}
            <a href={`tel:${BRAND.phoneRaw}`} className="text-[#AC9667] underline-offset-4 hover:underline">
              Give us a call at {BRAND.phone}
            </a>{" "}
            — we love thoughtful conversations.
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-white rounded-2xl border border-[#E5DDC9]/70 px-6 shadow-[0_4px_16px_-8px_rgba(15,23,42,0.08)]"
            >
              <AccordionTrigger className="text-left font-serif text-lg md:text-xl text-[#005165] hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[15px] text-[#4B5563] leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
